var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49878 14.5427V17.0748C2.49878 17.308 2.68202 17.4913 2.91524 17.4913H5.4473C5.55558 17.4913 5.66386 17.4496 5.73883 17.3663L14.8343 8.27922L11.7108 5.15578L2.62372 14.2429C2.54043 14.3262 2.49878 14.4261 2.49878 14.5427ZM17.2497 5.86376C17.5746 5.53892 17.5746 5.01418 17.2497 4.68935L15.3007 2.74032C15.2237 2.6631 15.1321 2.60183 15.0314 2.56002C14.9306 2.51822 14.8226 2.4967 14.7135 2.4967C14.6044 2.4967 14.4964 2.51822 14.3956 2.56002C14.2949 2.60183 14.2033 2.6631 14.1263 2.74032L12.6021 4.26456L15.7255 7.38799L17.2497 5.86376Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapis);
export default __webpack_public_path__ + "static/media/lapis.2f7482dbcff98fe9d32a2a780e4bc545.svg";
export { ForwardRef as ReactComponent };